import {Injectable} from '@angular/core';
import {DateUtils} from '@wba/utils/date.utils';
// Wegen SonarQube Major issue alle magic-numbers ersetzt
const TWO = 2;
const FOUR = 4;
const SIX = 6;
const EIGHT = 8;
const FIFTY = 50;
const HUNDRED = 100;

@Injectable()
export class DateConverterService {

  /**
   * Converting some user inputs to a valid date format
   * @param {string} value
   * @returns {string} in format 'DD.MM.YYYY'
   */
  public static convert(value: string): string {
    return this.isStringAndContainsDotsAndDigits(value) ? this.convertValidDate(value) : value;
  }

  /*
  * Checking if checkDate is between fromDate (incl.) and toDate (incl.)
  * @param {string} checkDate - format 'yyyy-mm-dd'
  * @param {string} fromDate - format 'yyyy-mm-dd'
  * @param {string} toDate - format 'yyyy-mm-dd'
  * @returns {boolean}
  * */
  public static isBetween(checkDate: string, fromDate: string, toDate: string): boolean {
    if (!DateUtils.isValid(checkDate, 'YYYY-MM-DD')
      || !DateUtils.isValid(fromDate, 'YYYY-MM-DD')
      || !DateUtils.isValid(toDate, 'YYYY-MM-DD')) {
      throw new Error('Invalid date');
    }

    const checkD = new Date(checkDate);
    const fromD = new Date(fromDate);
    const toD = new Date(toDate);

    return (checkD >= fromD) && (checkD <= toD);
  }

  private static isStringAndContainsDotsAndDigits(value: string) {
    return typeof value === 'string' && value.length > 0 && /^[.0-9 ]+$/.test(value);
  }

  private static twoDots(value: string) {
    return value.split('.').length - 1 === TWO || !value.includes('.');
  }

  private static convertValidDate(value: string) {
    let newVal = value.replaceAll(/ +/g, '');

    if (![FOUR, SIX, EIGHT].includes(newVal.length) || !DateConverterService.twoDots(newVal)) {
      return value;
    }

    newVal = this.convertInputWithoutDots(newVal);
    let year = newVal.split('.')[TWO];
    let month = newVal.split('.')[1];
    let day = newVal.split('.')[0];

    // YEAR
    if ((year.length != TWO && year.length != FOUR) || Number(year) <= 0) {
      return value;
    }
    year = this.convertYear(year);

    if (day.length > TWO || month.length > TWO) {
      return value;
    }

    // DAY
    day = (day.length === 1) ? `0${day}` : day;
    // MONTH
    month = (month.length === 1) ? `0${month}` : month;

    // month has length 2
    return `${day}.${month}.${year}`;
  }

  private static convertYear(year) {
    if (year.length === TWO) {
      // year.length === TWO
      if (Number(year) >= 0 && Number(year) < FIFTY) {
        // 00-49 --> 2049
        year = `20${year}`;
      } else if (Number(year) >= FIFTY && Number(year) < HUNDRED) {
        // 50-99 --> 2050
        year = `19${year}`;
      }
    }
    return year;
  }

  private static convertInputWithoutDots(input: string) {

    if (input.includes('.')) return input;

    switch (input.length) {
      case FOUR: return `${input.substring(0, 1)}.${input.substring(1, TWO)}.${input.substring(TWO, FOUR)}`;
      case SIX: return `${input.substring(0, TWO)}.${input.substring(TWO, FOUR)}.${input.substring(FOUR, SIX)}`;
      case EIGHT: return `${input.substring(0, TWO)}.${input.substring(TWO, FOUR)}.${input.substring(FOUR, EIGHT)}`;
      default: return input;
    }
  }
}
